import Tooltip from '@material-ui/core/Tooltip';
import React, { useRef, useState } from 'react';

import CustomTooltip from '@components/CustomTooltip';

import useClickOutside from '@hooks/useClickOutside';

import ProductTags from '@features/collection/details/ProductTags';
import { locationInfo } from '@features/design/utils/designUtils';
import { PRICE_RANGE_STATUS } from '@features/favourites/utils/favouriteUtil';

import { _getKey, getShortName, renderSetImages } from '@utils/Util';

import SetStyleSubCategory from '@/components/SetStyleSubCategory';

const FavouriteProductsListView = ({
	productList = [],
	selectedProducts,
	setSelectedProducts,
	index,
	onClickDesignImage,
	productWiseTags,
	fetchAllTags = () => {},
	updateProductTagOnSelect,
	setSelectedProductsWithDetails,
	selectedProductsWithDetails
}) => {
	const [selectedtRowId, setSeletedRowId] = useState(null);
	const tagRef = useRef();

	const handleSelectProduct = (e, item) => {
		const productId = e.target.value;
		if (e.target.checked) {
			setSelectedProducts([...selectedProducts, parseInt(productId)]);
			setSelectedProductsWithDetails([...selectedProductsWithDetails, item?.productResponse]);
		} else {
			setSelectedProducts(selectedProducts.filter((id) => id !== parseInt(productId)));
			setSelectedProductsWithDetails(
				selectedProductsWithDetails.filter((product) => product.id !== parseInt(productId))
			);
		}
	};

	const hanleCloseTags = () => {
		setSeletedRowId(null);
	};

	useClickOutside(tagRef, hanleCloseTags);

	const handleAllSelect = (e) => {
		const allProductIds = productList.map((item) => item.productResponse.id);
		if (e.target.checked) {
			setSelectedProducts([...new Set([...selectedProducts, ...allProductIds])]);
			setSelectedProductsWithDetails(productList.map((item) => item?.productResponse));
		} else {
			setSelectedProducts(selectedProducts.filter((id) => !allProductIds.includes(id)));
			setSelectedProductsWithDetails([]);
		}
	};

	const getSampleId = (sample) => {
		return sample?.sampleId;
	};

	const tableRow = () => {
		return (
			<>
				{productList?.map((item, itemIndex) => (
					<React.Fragment key={`${item?.id}-${itemIndex}`}>
						<tr>
							<td
								className="select-box-column"
								rowSpan={item?.productResponse?.sampleInventoryItemResponseList?.length || 1}
							>
								<div className="custom-chekbox">
									<div className="form-group m-0">
										<input
											type="checkbox"
											id={`${item?.productResponse?.id}-${index}-${itemIndex}`}
											name={`product_${item?.productResponse?.id}`}
											value={item?.productResponse?.id}
											onChange={(e) => handleSelectProduct(e, item)}
											checked={selectedProducts.includes(item?.productResponse?.id)}
										/>
										<label
											htmlFor={`${item?.productResponse?.id}-${index}-${itemIndex}`}
										/>
									</div>
								</div>
							</td>
							<td
								className="style-details-column design-column"
								rowSpan={item?.productResponse?.sampleInventoryItemResponseList?.length || 1}
								onClick={() => onClickDesignImage(item?.productResponse)}
							>
								<div className="d-flex align-items-center">
									{item?.productResponse?.isSet ? (
										renderSetImages(item?.productResponse?.designDocuments, '56px')
									) : (
										<img
											src={item?.productResponse?.designDocuments?.[0]?.docUrl}
											alt=""
											className="cell-img pr-2 cursor-pointer"
										/>
									)}

									<div
										className="d-inline-block align-middle ml-1 cursor-pointer"
										data-toggle="modal"
										data-target="#designViewModal"
									>
										{item?.productResponse?.isSet && (
											<span className="status set">Set</span>
										)}
										{item?.productResponse?.isPack && (
											<span className="status pack">Pack</span>
										)}
										<p className="regular-12 weight-500 gray_dark_01 my-1">
											{item?.productResponse?.referenceNumber}
										</p>
										<ul className="common-list-component mb-1">
											{!item?.productResponse?.isSet &&
												item?.productResponse?.productGroup && (
													<li>{item?.productResponse?.productGroup}</li>
												)}
											{item?.productResponse?.isSet &&
												item?.productResponse?.setMemberProducts?.[0]
													?.productGroup && (
													<li>
														{
															item?.productResponse?.setMemberProducts?.[0]
																?.productGroup
														}
													</li>
												)}
											{!item?.productResponse?.isSet &&
												item?.productResponse?.subCategory && (
													<li>
														<Tooltip
															title={item?.productResponse?.subCategory || ''}
															placement="top"
															arrow
														>
															<span>
																{getShortName(
																	item?.productResponse?.subCategory,
																	25
																)}
															</span>
														</Tooltip>
													</li>
												)}
											{item?.productResponse?.isSet && (
												<SetStyleSubCategory product={item?.productResponse} />
											)}
											{item?.productResponse?.addedByName && (
												<li>
													<Tooltip
														title={
															<span className="regular-14">
																{item?.productResponse?.addedByName || ''}
															</span>
														}
														placement="top"
														arrow
													>
														<span>
															{getShortName(
																item?.productResponse?.addedByName,
																10
															)}
														</span>
													</Tooltip>
												</li>
											)}
										</ul>
									</div>
								</div>
							</td>
							<td
								className="status-date-column costing-column"
								rowSpan={item?.productResponse?.sampleInventoryItemResponseList?.length || 1}
							>
								<span
									className={`${
										PRICE_RANGE_STATUS.find(
											(status) =>
												status.value ===
												item?.productResponse?.costingReviewAssessmentResponse
													?.constant
										)?.className
									} mb-1`}
								>
									{item?.productResponse?.costingReviewAssessmentResponse?.name}
								</span>
								{item?.productResponse?.basePrice && (
									<p>{item?.productResponse?.basePrice?.toFixed(2)} $</p>
								)}
							</td>

							<td className="location-td">
								{getSampleId(item?.productResponse?.sampleInventoryItemResponseList?.[0])}
							</td>
							<td className="location-td">
								{item?.productResponse?.sampleInventoryItemResponseList?.length > 0 && (
									<p>
										{locationInfo({
											...item?.productResponse?.sampleInventoryItemResponseList?.[0],
											...item?.productResponse?.sampleInventoryItemResponseList?.[0]
												?.sampleInventoryLocationResponse
										})}
									</p>
								)}
							</td>

							<td
								className="fabric-column"
								rowSpan={item?.productResponse?.sampleInventoryItemResponseList?.length || 1}
							>
								<ul className="with-bullet">
									{item?.productResponse?.mainFabricResponses &&
										item?.productResponse?.mainFabricResponses.map((fabric) => (
											<li className="regular-12 gray_dark_02" key={fabric?.id}>
												{fabric?.name}
											</li>
										))}
								</ul>
							</td>
							<td
								className="trims fabric-column"
								rowSpan={item?.productResponse?.sampleInventoryItemResponseList?.length || 1}
							>
								<ul className="with-bullet">
									{item?.productResponse?.trimsResponses?.map((trim) => (
										<li className="regular-12 gray_dark_02" key={trim?.id}>
											<CustomTooltip
												placement="top"
												arrowCenter={true}
												text={trim?.name}
												className={trim?.name?.length > 120 ? 'show' : 'hide'}
											>
												{getShortName(trim?.name, 120)}
											</CustomTooltip>
										</li>
									))}
								</ul>
							</td>
							<td
								className="tag tag-columm"
								rowSpan={item?.productResponse?.sampleInventoryItemResponseList?.length || 1}
								onClick={() => setSeletedRowId(item?.productResponse?.id)}
							>
								<div className="design-tags">
									{item?.productResponse?.tagResponseList?.map((tag) => (
										<span
											key={`all_tags_${tag?.id}`}
											style={{ background: tag?.colorCode }}
											className="status radius"
										>
											{tag?.text}
										</span>
									))}
								</div>
								{selectedtRowId === item?.productResponse?.id && (
									<div ref={tagRef}>
										<ProductTags
											currentProductTagList={item?.productResponse?.tagResponseList}
											productId={item?.productResponse?.id}
											allTagList={productWiseTags}
											fetchAllTags={fetchAllTags}
											updateTagList={updateProductTagOnSelect}
										/>
									</div>
								)}
							</td>
							<td rowSpan={item?.productResponse?.sampleInventoryItemResponseList?.length || 1}>
								{item?.productResponse?.collectionRemarks}
							</td>
						</tr>
						{item?.productResponse?.sampleInventoryItemResponseList?.slice(1).map((sample) => (
							<tr>
								<td className="location-td">{getSampleId(sample)}</td>
								<td className="location-td">
									{locationInfo({
										...sample,
										...sample?.sampleInventoryLocationResponse
									})}
								</td>
							</tr>
						))}
					</React.Fragment>
				))}
			</>
		);
	};

	const uniqueId = _getKey();

	return (
		<div className="favourite-table">
			<table className="table with-border no-hover">
				<thead>
					<tr>
						<th className="select-box-column">
							<div className="custom-chekbox">
								<div className="form-group m-0">
									<input
										type="checkbox"
										name={uniqueId}
										id={uniqueId}
										onChange={(e) => handleAllSelect(e)}
										checked={productList?.every((item) =>
											selectedProducts.includes(item.productResponse.id)
										)}
									/>
									<label htmlFor={uniqueId} />
								</div>
							</div>
						</th>
						<th>Design</th>
						<th>Costing</th>
						<th>Sample ID</th>
						<th>Location</th>
						<th>Fabric</th>
						<th>Trims</th>
						<th>Tag</th>
						<th>Remark</th>
					</tr>
				</thead>
				<tbody>{tableRow()}</tbody>
			</table>
		</div>
	);
};

export default FavouriteProductsListView;
